var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTileMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58.318,
    height: 29.64,
    viewBox: "0 0 58.318 29.64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2736.29 463.244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2671.44-447.037c-3.761,4.007-10.251,11.167-25.12,11.674l-4.925,4.925c1.052.1,2.13.157,3.235.157,17.424,0,25.333-11.45,28.174-16.042,1.026-1.659.157-2.335-1.365-.714",
    transform: "translate(-8.874 -3.823)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2683.989-456.215a18.035,18.035,0,0,0,3.345,1.653,6.976,6.976,0,0,0,2.771.339s-4.129-3.516-5.739-4.822l-2.257,2.258a3.711,3.711,0,0,1,1.88.573",
    transform: "translate(-12.916 -0.955)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2701.584-431.3a39.017,39.017,0,0,1-9.168-1.08l-3.609,3.609a33.641,33.641,0,0,0,9.541,2.366l4.926-4.926q-.827.03-1.691.03",
    transform: "translate(-5.541 -7.857)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2700.486-456.642c1.14.371,2.094.88,3.062,1.106a5.7,5.7,0,0,0,2.464-.022c1.4-.422,2.467-1.07,3.519-1.393a4.19,4.19,0,0,1,1.3-.2l2.257-2.258c-.213-.172-.382-.307-.491-.388-.94-.706-1.334-.859-2.169-.385-.939.534-3.271,1.731-4.39,2.307-.8.414-.953.381-1.453-.107-.667-.649-1.6-1.595-2.386-2.446l-3.6,3.6a4.621,4.621,0,0,1,1.89.185",
    transform: "translate(-8.644 -0.589)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2724.636-434.2a35.479,35.479,0,0,0,7.614,4.291l3.609-3.609a37.552,37.552,0,0,1-8.66-3.248Z",
    transform: "translate(-2.881 -6.723)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2731.19-443.39l-1.651,1.651a31.319,31.319,0,0,0,6.078,5.827l2.566-2.565a31.553,31.553,0,0,1-7-4.912",
    transform: "translate(-0.757 -5.007)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2735.766 -462.733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2704.081-462.376c-.418-.534-.983-.405-1.586-.022-.854.543-12.591,7.865-12.591,7.865a4.209,4.209,0,0,0,2.014.192,22.126,22.126,0,0,0,6.581-2.114,10.468,10.468,0,0,1,3.17-.96l3.6-3.6c-.482-.519-.912-1-1.191-1.359",
    transform: "translate(2731.233 462.733)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2734.289-447.27c-.908-1.374-1.821-.494-1.347.9a12.968,12.968,0,0,0,2.038,3.449l1.651-1.651a16.2,16.2,0,0,1-2.341-2.7",
    transform: "translate(2735.766 458.908)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTileMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tile-mark.6dfe923c.svg";
export { ForwardRef as ReactComponent };